import {
  Criteria,
  NestedQuota,
} from '../../../shared/interfaces/quota.interface';
import { SurveyQuotaCriterion } from '../../domain/survey-quota-criterion';

interface CriteriaBuild {
  build(): Criteria[];
}

export class NestedQuotaGroupCriteriaBuilder implements CriteriaBuild {
  constructor(private readonly _selectedNestedQuotas: NestedQuota[]) {}

  public build(): Criteria[] {
    return this._selectedNestedQuotas.reduce(
      (criteria: Criteria[], selectedNestedQuota: NestedQuota) => {
        if (!criteria.length) {
          return selectedNestedQuota.criteria;
        }
        return this._combine(criteria, selectedNestedQuota.criteria);
      },
      <Criteria[]>[]
    );
  }

  private _combine(
    firstCriteria: Criteria[],
    SecondCriteria: Criteria[]
  ): Criteria[] {
    return firstCriteria.map((firstCriterion) => {
      const matchingCriterion = SecondCriteria.find(
        (secondCriterion) =>
          secondCriterion.qualification_code ===
          firstCriterion.qualification_code
      )!;
      return this._combineConditions(firstCriterion, matchingCriterion);
    });
  }

  private _combineConditions(
    firstCriterion: Criteria,
    secondCriterion: Criteria
  ): Criteria {
    if (new SurveyQuotaCriterion(firstCriterion).isRange()) {
      return {
        ...firstCriterion,
        range_sets: [
          ...new Map(
            [
              ...new SurveyQuotaCriterion(firstCriterion).range(),
              ...new SurveyQuotaCriterion(secondCriterion).range(),
            ].map((v) => [v['from'], v])
          ).values(),
        ],
      };
    }

    return {
      ...firstCriterion,
      condition_codes: [
        ...new Set([
          ...new SurveyQuotaCriterion(firstCriterion).conditions(),
          ...new SurveyQuotaCriterion(secondCriterion).conditions(),
        ]),
      ],
      condition_names: [
        ...new Set([
          ...new SurveyQuotaCriterion(firstCriterion).conditionNames(),
          ...new SurveyQuotaCriterion(secondCriterion).conditionNames(),
        ]),
      ],
    };
  }
}
